import { missingNativeBuild } from "../nativeError";
import { assertIdentifier, assertRegion, assertRegionListener } from "./validation";
var Location = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestWhenInUsePermission: function requestWhenInUsePermission() {
    return Promise.resolve("denied");
  },
  requestAlwaysAuthorization: function requestAlwaysAuthorization() {
    return Promise.resolve("denied");
  },
  getCurrentPosition: function getCurrentPosition() {
    return Promise.reject(missingNativeBuild("Location.getCurrentPosition"));
  },
  watchPosition: function watchPosition(_onPosition, _onError) {
    var _options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function() {
    };
  },
  geocodeAddress: function geocodeAddress(_address) {
    return Promise.resolve([]);
  },
  reverseGeocode: function reverseGeocode(_latitude, _longitude) {
    return Promise.resolve([]);
  },
  startMonitoring: function startMonitoring(region) {
    assertRegion(region, "startMonitoring");
    return Promise.resolve();
  },
  stopMonitoring: function stopMonitoring(identifier) {
    assertIdentifier(identifier, "stopMonitoring");
    return Promise.resolve();
  },
  monitoredRegions: function monitoredRegions() {
    return [];
  },
  requestState: function requestState(identifier) {
    assertIdentifier(identifier, "requestState");
    return Promise.resolve("unknown");
  },
  addDidEnterRegionListener: function addDidEnterRegionListener(listener) {
    assertRegionListener(listener, "addDidEnterRegionListener");
    return {
      remove: function remove() {
      }
    };
  },
  addDidExitRegionListener: function addDidExitRegionListener(listener) {
    assertRegionListener(listener, "addDidExitRegionListener");
    return {
      remove: function remove() {
      }
    };
  }
});
export {
  Location
};
//# sourceMappingURL=unavailable.js.map
